import { routenames } from '@/router/routenames';
import type { NavigationEntryRaw } from '../types';

export const resultManagementNavigationRaw: NavigationEntryRaw[] = [
  {
    titleI18n: 'Trends',
    route: { name: routenames.trends },
  },
];
